type ResizeMode = 'cover' | 'contain' | 'fill';

type SupabaseImageTransformOptions = {
    width?: number;
    height?: number;
    quality?: number;
    resize?: ResizeMode;
};

const RENDER_SEGMENT = '/storage/v1/render/image/public/';
const OBJECT_SEGMENT = '/storage/v1/object/public/';

const normalizeBaseUrl = (rawUrl?: string | null): string => {
    const normalized = String(rawUrl || '').trim();
    if (!normalized) {
        return '';
    }

    if (normalized.includes(RENDER_SEGMENT)) {
        return normalized;
    }

    if (normalized.includes(OBJECT_SEGMENT)) {
        return normalized.replace(OBJECT_SEGMENT, RENDER_SEGMENT);
    }

    return normalized;
};

export const buildSupabaseImageUrl = (
    rawUrl?: string | null,
    options: SupabaseImageTransformOptions = {},
): string => {
    const baseUrl = normalizeBaseUrl(rawUrl);
    if (!baseUrl.includes(RENDER_SEGMENT)) {
        return baseUrl;
    }

    const {width, height, quality, resize} = options;
    const queryParts: string[] = [];

    if (width) {
        queryParts.push(`width=${width}`);
    }
    if (height) {
        queryParts.push(`height=${height}`);
    }
    if (quality) {
        queryParts.push(`quality=${quality}`);
    }
    if (resize) {
        queryParts.push(`resize=${resize}`);
    }

    if (queryParts.length === 0) {
        return baseUrl;
    }

    const separator = baseUrl.includes('?') ? '&' : '?';
    return `${baseUrl}${separator}${queryParts.join('&')}`;
};
